module.exports = __webpack_public_path__ + "static/media/ico_arrow.190f921f.png";